<template>
  <div class="skeleton" :class="{ 'no-animation': !animation }" :style="{ width: width, height: height }"></div>
</template>
<script>
  export default {
    props: {
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: String,
        default: '100%',
      },
      animation: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>
<style lang="scss" scoped>
  .skeleton {
    margin: 12px 0;
    border-radius: 4px;
    animation: pulse-bg 1.3s infinite;
    &.no-animation {
      animation: none;
    }
  }
  @keyframes pulse-bg {
    0% {
      background-color: #ddd;
    }
    50% {
      background-color: #d3d3d3;
    }
    100% {
      background-color: #ddd;
    }
  }
</style>
